export function inferSurfBlobKind(file) {
    const mime = file.type.toLowerCase();
    const name = file.name.toLowerCase();
    if (mime.startsWith("image/") || /\.(jpe?g|png|gif|webp|heic)$/.test(name))
        return "image";
    if (mime === "application/pdf" || name.endsWith(".pdf"))
        return "pdf";
    if (mime.startsWith("video/") || /\.(mp4|mov|webm)$/.test(name))
        return "video";
    return "file";
}
function normalizedContentType(file, kind) {
    if (file.type.trim())
        return file.type;
    switch (kind) {
        case "image":
            return "image/jpeg";
        case "pdf":
            return "application/pdf";
        case "video":
            return "video/mp4";
        default:
            return "application/octet-stream";
    }
}
async function requestSurfUploadUrl(cfg, kind, filename, contentLength, contentType, ownerId) {
    const base = cfg.presignedBaseUrl?.replace(/\/+$/, "");
    if (!base)
        throw new Error("Storage cloud non configurato.");
    const token = await cfg.getIdToken();
    let res;
    try {
        res = await fetch(`${base}/blob/upload-url`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                kind,
                filename,
                contentLength,
                contentType,
                ownerId,
            }),
        });
    }
    catch (e) {
        if (e instanceof TypeError) {
            throw new Error("Impossibile contattare lo storage cloud (rete o CORS). Riprova tra poco.");
        }
        throw e;
    }
    const text = await res.text();
    if (!res.ok)
        throw new Error(`Upload URL (${res.status}): ${text.slice(0, 200)}`);
    const json = JSON.parse(text);
    if (!json.url || !json.s3Key)
        throw new Error("Risposta upload non valida.");
    return {
        url: json.url,
        s3Key: json.s3Key,
        publicURL: json.publicURL ?? "",
    };
}
/** Upload a browser File to S3 via pdf-presigned blob API (F18). */
export async function uploadSurfBlobFile(cfg, file, 
// The server always namespaces blobs under the authenticated user; ownerId does
// NOT affect the key prefix (kept only for the API shape / metadata).
ownerId = "surf") {
    const kind = inferSurfBlobKind(file);
    if (kind !== "image") {
        throw new Error("Per Surf carica solo immagini di riferimento (JPEG/PNG/WebP).");
    }
    const contentType = normalizedContentType(file, kind);
    const presigned = await requestSurfUploadUrl(cfg, kind, file.name, file.size, contentType, ownerId);
    const putRes = await fetch(presigned.url, {
        method: "PUT",
        headers: {
            "Content-Type": contentType,
            "Content-Length": String(file.size),
        },
        body: file,
    });
    if (!putRes.ok)
        throw new Error(`Upload blob (${putRes.status})`);
    return { s3Key: presigned.s3Key, publicURL: presigned.publicURL };
}
